import classNames from 'classnames';
import { t } from 'ttag';

import { ProductSaleStatus, SellingConditionEnum } from '@models';
import { useRegion } from '@hook/useRegion';
import { ProductSaleLabel } from '@components/ProductSaleLabel';

import s from './ProductDetailsPrice.sss';

interface SaleLabel {
  status: ProductSaleStatus,
  date: string,
  price: number,
}

interface Product {
  id: number,
  price?: number | null,
  oldPrice?: number | null,
  discountPercent?: number | null,
  saleLabel: SaleLabel,
  sellingCondition: SellingConditionEnum,
}

interface Props {
  className?: string,
  product: Product,
}

export const ProductDetailsPrice: React.FC<Props> = ({
  className,
  product,
}) => {
  const { currencyName } = useRegion();

  return (
    <div className={classNames(s.root, className)}>
      {product.sellingCondition === SellingConditionEnum.Gift && (
        <p className={s.gift}>
          {t`У подарунок`}
        </p>
      )}

      {product.sellingCondition === SellingConditionEnum.Exchange && (
        <p className={s.swap}>
          SWAP
        </p>
      )}

      {[SellingConditionEnum.Sale, SellingConditionEnum.ForSaleAndExchange].includes(product.sellingCondition) && (
        <>
          {!!product.oldPrice && (
            <>
              <span className={s.oldPrice}>
                {product.oldPrice}
                &nbsp;
                {currencyName}
              </span>

              {product.saleLabel.status === ProductSaleStatus.SaleNone && !!product.discountPercent && (
                <span className={classNames(s.label, s.labelTypeDiscount)}>
                  {`-${product.discountPercent}%`}
                </span>
              )}
            </>
          )}

          {[ProductSaleStatus.SaleNotStarted, ProductSaleStatus.SaleStarted].includes(product.saleLabel.status) && (
            <ProductSaleLabel
              className={s.saleLabel}
              status={product.saleLabel.status}
              price={product.saleLabel.price}
              date={product.saleLabel.date}
              isShortMonthName={false}
            />
          )}

          <p className={s.price}>
            {product.saleLabel.status === ProductSaleStatus.SaleStarted ? (
              `${product.saleLabel.price} ${currencyName}`
            ) : (
              `${product.price} ${currencyName}`
            )}
          </p>
        </>
      )}
    </div>
  );
};
